<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    [description]="widgetRef.widgetDescription"
    (onIntegrate)="onIntegrate()"
></app-integration>
